<i18n>
{
  "fr": {
    "form-list-title": "Liste des demandes",
    "id-label": "N°",
    "project-name-label": "Nom du projet",
    "owner-name-label": "Auteur du dépôt",
    "supervisor-name-label": "Maître d'ouvrage",
    "status-label": "Statut de la demande",
    "status-undefined": "Non défini",
    "status-waiting": "En attente de téléversement",
    "status-cancel": "Annulé",
    "status-running": "En cours",
    "status-done": "Terminé",
    "create-label": "Date de création",
    "last-update-label": "Dernière modification",
    "actions-label": "Actions",
    "dialog-delete-confirm-title": "Supprimer",
    "dialog-delete-confirm-content": "Êtes-vous sûr de vouloir supprimer cet élément ?",
    "dialog-delete-confirm-button": "Oui",
    "dialog-delete-cancel-button": "Annuler",
    "deathline-label": "Délai",
    "deathline-nb-days": "aujourd'hui | demain | {nbDays} jours",
    "filter-title": "Filtres",
    "formData-type": "Type de données",
    "level-title": "Niveaux d'eau",
    "sourceflow-title": "Débits",
    "quant-data-title": "Données quantitatives",
    "qual-data-title": "Données qualitatives",
    "in-situ-measure-title": "Mesures in-situ",
    "sample-title": "Echantillonnage",
    "observation-description-title": "Points d'observation (informations descriptives)",
    "piezo-label": "Piézomètres",
    "well-label": "Puits",
    "sources-label": "Sources",
    "other-label": "Autres",
    "plotting-test-label": "Essai de traçage",
    "report-title": "Documents",
    "export-label": "Exporter la liste"
  },
  "de": {
    "form-list-title": "Liste der Anfragen",
    "id-label": "Nr.",
    "project-name-label": "Name des Projekt",
    "owner-name-label": "Gesuchsteller",
    "supervisor-name-label": "Bauherr",
    "status-label": "Status des anfrage",
    "status-undefined": "undefiniert",
    "status-waiting": "Warten auf Upload",
    "status-cancel": "Storniert",
    "status-running": "Im Gang",
    "status-done": "Fertig",
    "create-label": "Erstellungsdatum",
    "last-update-label": "Letzte Änderung",
    "actions-label": "Handeln",
    "dialog-delete-confirm-title": "Löschen",
    "dialog-delete-confirm-content": "Möchten Sie diesen Artikel wirklich löschen?",
    "dialog-delete-confirm-button": "Ja",
    "dialog-delete-cancel-button": "Abbrechen",
    "level-title": "Wasserspiegel",
    "sourceflow-title": "Fluss",
    "quant-data-title": "Quantitative Daten",
    "qual-data-title": "Qualitative Daten",
    "in-situ-measure-title": "In-situ Messungen",
    "sample-title": "Sampling",
    "observation-description-title": "Überwachungsstellen (Beschreibende informationen)",
    "piezo-label": "Piézometer",
    "well-label": "Schacht",
    "sources-label": "Quellen",
    "other-label": "Anderes"
  }
}
</i18n>

<template>
  <div id="collect-data-gw" class="geo-forms">

    <Header :title="$t('form-list-title')" />

    <md-content class="md-elevation-1 main-container filter-container">
      <h3 class="title" v-on:click="filter.isPaneOpen = !filter.isPaneOpen">
        <md-icon v-if="filter.isPaneOpen">keyboard_arrow_up</md-icon>
        <md-icon v-if="!filter.isPaneOpen">keyboard_arrow_down</md-icon>
        {{$t('filter-title')}}
      </h3>
      <div class="filter-content" v-if="filter.isPaneOpen">
        <md-divider></md-divider>

        <div class="filter-section">
          <div class="md-layout">
            <md-checkbox class="md-layout-item md-size-25" v-model="filter.data.hasObservationPoint">{{ $t('observation-description-title') }}</md-checkbox>
            <md-checkbox class="md-layout-item md-size-25" v-model="filter.data.hasQuantData">{{ $t('quant-data-title') }}</md-checkbox>
            <md-checkbox class="md-layout-item md-size-25" v-model="filter.data.hasQualdata">{{ $t('qual-data-title') }}</md-checkbox>
            <md-checkbox class="md-layout-item md-size-25" v-model="filter.data.hasPlottingTest">{{ $t('plotting-test-label') }}</md-checkbox>
            <md-checkbox class="md-layout-item md-size-25" v-model="filter.data.hasReport">{{ $t('report-title') }}</md-checkbox>
          </div>
        </div>

        <md-divider></md-divider>

      </div>
    </md-content>

    <md-content class="md-elevation-3 main-container form-list-container">

      <div class="action-section">
        <md-button class="md-raised" @click="exportToCsv">{{ $t('export-label') }}</md-button>
      </div>

      <md-table v-model="filtredForms" md-card md-sort="projectName" @md-selected="onFormSelect">

        <md-table-row :class="getRowClass(item)" slot="md-table-row" slot-scope="{ item }" md-selectable="single">
          <md-table-cell :md-label="$t('id-label')" md-sort-by="id">
            <div v-if="item.isLate()" class="red-dot"></div>
            {{ item.publicId }}
          </md-table-cell>
          <md-table-cell :md-label="$t('status-label')" md-sort-by="status">{{ $t(`status-${item.status}`) }}</md-table-cell>
          <md-table-cell :md-label="$t('project-name-label')" md-sort-by="project.name">{{ item.project.name }}</md-table-cell>
          <md-table-cell :md-label="$t('owner-name-label')" md-sort-by="projectOwner.companyName">{{ item.projectOwner.companyName }}</md-table-cell>
          <md-table-cell :md-label="$t('supervisor-name-label')" md-sort-by="projectSupervisor.companyName">{{ item.projectSupervisor.companyName }}</md-table-cell>
          <md-table-cell :md-label="$t('create-label')" md-sort-by="createDate">{{ item.createDate }}</md-table-cell>
          <md-table-cell :md-label="$t('last-update-label')" md-sort-by="lastUpdateDate">{{ item.lastUpdateDate }}</md-table-cell>
          <md-table-cell :md-label="$t('deathline-label')" md-sort-by="formattedDeathline">{{ item.deathline === null ? '-' : $tc('deathline-nb-days', item.nbDaysBeforeDeathline, {nbDays: item.nbDaysBeforeDeathline} )}}</md-table-cell>
          <md-table-cell v-if="accessToken.canDelete('forms')" :md-label="$t('actions-label')"><md-button @click.stop.native="showDialogDelete = true; itemToDelete = item"><md-icon>delete_forever</md-icon></md-button></md-table-cell>
        </md-table-row>
      </md-table>
    </md-content>

    <md-dialog-confirm
      :md-active.sync="showDialogDelete"
      :md-title="$t('dialog-delete-confirm-title')"
      :md-content="$t('dialog-delete-confirm-content')"
      :md-confirm-text="$t('dialog-delete-confirm-button')"
      :md-cancel-text="$t('dialog-delete-cancel-button')"
      @md-cancel="showDialogDelete = false; itemToDelete = null"
      @md-confirm="onDeleteConfirm"
    />

    <Snackbar ref="snackbar" />

  </div>
</template>

<script>

import Vue from 'vue'
import FormCollectDataGW from '../../models/FormCollectDataGW/Form'
import Header from '@/components/header'
import Snackbar from '@/components/snackbar'
import moment from 'moment'

import AccessToken from '@/helpers/access-token'

export default {
  name: 'ListForms',
  components: {
    Header,
    Snackbar
  },
  data () {
    return {
      forms: [],
      filtredForms: [],
      showDialogDelete: false,
      itemToDelete: null,
      filter: {
        isPaneOpen: false,
        data: {
          hasObservationPoint: false,
          hasQuantData: false,
          hasQualdata: false,
          hasPlottingTest: false,
          hasReport: false
        }
      },
      accessToken: AccessToken.get()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadData().then(() => {

      }).catch(this.handleError)
    })
  },
  computed: {
    hasFilterSelected () {
      return true
    }
  },
  watch: {
    filter: {
      deep: true,
      handler (val) {
        this.filtredForms = FormCollectDataGW.filter(this.forms, val.data)
      }
    }
  },
  methods: {
    loadData () {
      return new Promise((resolve, reject) => {
        let toFetch = []
        toFetch.push(FormCollectDataGW.list())

        Promise.all(toFetch).then((data) => {
          this.forms = this.filtredForms = data[0]
          resolve()
        }).catch(reject)
      })
    },
    onFormSelect (form) {
      this.$router.push({
        name: 'form-collect-data-gw-follow',
        params: { id: form.publicId }
      })
    },
    getRowClass (form) {
      return `form-${form.status}`
    },
    deleteForm (form) {
      form.delete().then(() => {
        Vue.delete(this.forms, this.forms.indexOf(form))
      })
    },
    onDeleteConfirm () {
      this.deleteForm(this.itemToDelete)
      this.itemToDelete = null
    },
    exportToCsv () {
      let toDownload = FormCollectDataGW.toCsv(this.filtredForms)

      // HACK to download requested AJAX file
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([toDownload]))
      link.download = `datalake_CDGW_list_${moment().format('DD.MM.YYYY')}.csv`
      link.click()
    },
    handleError (e) {
      this.$refs.snackbar.showError(e)
    }
  }
}
</script>

<style lang="scss">
@import '@/scss/colors.scss';

.group-field {
  padding: 20px;
}

.md-layout-item {
  padding: 10px;
}

.map {
  width: 100%;
  height:400px;
}

.md-select-menu.md-menu-content-bottom-start.md-menu-content-small.md-menu-content.md-theme-default {
  @media(max-width: 960px) {
    left: 10px !important;
    max-width: calc(100% - 20px);
  }
  @media(min-width: 960px){
    max-width: 50%
  }
}

.red-dot {
  background-color:red;
  width: 5px;
  height: 5px;
  display: inline-block;
  border-radius: 5px;
  margin-bottom: 2px;
}

.form-waiting {
  background-color: $color-waiting;
}

.form-running {
  background-color: $color-running;
}

.form-done {
  background-color: $color-done;
}

.form-list-container {

  padding-top: 5px;

  .action-section {
    margin-bottom: 5px;
    text-align: right;

    & .md-button {
      text-transform: none;
    }

    & .md-button:last-child {
      margin-right: 0px;
    }
  }

}

.filter-container {
  margin-bottom: 15px;
  padding: 10px;
  user-select: none;

  .title {
    margin: 0px;
    color: grey;
    cursor: pointer;
  }

  .filter-section {
    padding-bottom: 10px;
    padding-top: 10px;

    &:last-child {
      padding-bottom: 0px;
    }
  }

  .filter-content {
    padding: 5px;

    h3 {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .md-layout > * {
      margin-top: 7px;
      margin-bottom: 7px;
      padding-top: 7px;
      padding-bottom: 7px;
    }
  }
}

</style>
